/**
 * PRESCH Analytics — GA4 Custom Events (Spezifikation: GA4_Event_Implementierung_PRESCH.md).
 *
 * Alle Listener laufen per Event-Delegation auf `document`, damit sie auch
 * Inhalte erfassen, die Horizon nachlädt oder im Theme-Editor neu rendert.
 * Einziger gtag-Zugang ist `preschTrack` — ist gtag (z. B. wegen Consent)
 * nicht geladen, passiert nichts.
 */
(function () {
  'use strict';

  /**
   * Ereignisse, die feuern, bevor es ein gtag gibt, warten hier.
   *
   * Warum ueberhaupt: Das gtag-Stub wird nicht vom Theme gesetzt, sondern vom
   * Consent-Werkzeug (Pandectes), und das laedt spaet. Gemessen war
   * `pandectes-core.js` erst bei 1440ms fertig, DOMContentLoaded aber schon bei
   * 1375ms — alles, was beim Laden feuert (search_no_results), fand kein gtag
   * und verfiel stillschweigend.
   *
   * Warum nicht einfach selbst in den dataLayer schieben: Google verarbeitet
   * die Warteschlange in genau der Reihenfolge, in der sie darin liegt, und
   * ein `event` VOR dem `consent default` des Werkzeugs gilt als vollstaendig
   * erlaubt. Ein Eintrag, den wir vorziehen, wuerde die Einwilligung also
   * umgehen. Deshalb warten wir hier ab, bis das Werkzeug seine Vorgaben
   * gesetzt hat — daran erkennbar, dass es `gtag` definiert hat.
   */
  var warteschlange = [];
  var waechterLaeuft = false;

  function starteWaechter() {
    if (waechterLaeuft) return;
    waechterLaeuft = true;
    var versuche = 0;
    var takt = setInterval(function () {
      versuche++;
      if (typeof window.gtag === 'function') {
        clearInterval(takt);
        waechterLaeuft = false;
        var offen = warteschlange;
        warteschlange = [];
        for (var i = 0; i < offen.length; i++) {
          window.gtag('event', offen[i][0], offen[i][1]);
        }
      } else if (versuche >= 40) {
        // Nach 10 Sekunden ohne gtag gibt es keins: verwerfen statt sammeln.
        clearInterval(takt);
        waechterLaeuft = false;
        warteschlange = [];
      }
    }, 250);
  }

  function preschTrack(eventName, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params || {});
      return;
    }
    warteschlange.push([eventName, params || {}]);
    starteWaechter();
  }

  // Global, damit Liquid-Inline-Skripte (search_no_results) ihn aufrufen können.
  window.preschTrack = preschTrack;

  /**
   * Produkttitel des HAUPT-Produkts der Seite — nur auf Produkt-Templates.
   *
   * Der Parameter heisst `produkt_name` und ausdruecklich NICHT `item_name`:
   * Letzteres ist bei GA4 ein reservierter Name fuer Produkte innerhalb des
   * `items[]`-Arrays. Flach als Ereignisparameter gesendet kommt er zwar an,
   * fuellt aber die eingebaute Dimension "Artikelname" nicht — man haette also
   * zwei Spalten mit demselben Anspruch, eine gefuellte aus dem E-Commerce-
   * Tracking und eine eigene aus diesen Ereignissen. Der eigene Name macht die
   * Verwechslung unmoeglich.
   * Produktkarten in Grids tragen ebenfalls [data-product-title]; ohne die
   * Template-Prüfung würde z. B. ein FAQ-Klick auf einer Collection-Seite den
   * Titel der ersten Karte als produkt_name melden.
   */
  function productTitle() {
    var main = document.getElementById('MainContent');
    if (!main || (main.dataset.template || '').indexOf('product') !== 0) return undefined;
    var el = main.querySelector('h1[data-product-title]')
      || main.querySelector('[data-template-product-match][data-product-title]')
      || main.querySelector('variant-picker[data-product-title]');
    var value = el ? el.getAttribute('data-product-title') || el.textContent : '';
    if (!value || !value.trim()) {
      var h1 = main.querySelector('h1');
      value = h1 ? h1.textContent : '';
    }
    value = (value || '').trim();
    return value || undefined;
  }

  // 1a. Filter angewendet (Horizon-Facetten: alle Filter-Inputs heißen "filter.…")
  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;
    var el = e.target.closest('[data-filter-type], input[name^="filter."]');
    if (!el || !el.checked) return;
    var filterType = el.dataset.filterType;
    if (!filterType) {
      // Fallback für Checkbox-Filter ohne data-Attribute: Label der Facette
      var panel = el.closest('details');
      var label = panel && panel.querySelector('.facets__label');
      filterType = label ? label.textContent.trim() : el.name;
    }
    preschTrack('filter_applied', {
      filter_type: filterType,
      filter_value: el.dataset.filterValue || el.dataset.label || el.value
    });
  });

  // 1b. Sortierung geändert (Select auf Mobile, Radios im Desktop-Dropdown)
  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;
    var el = e.target.closest('[data-sort-select], select[name="sort_by"], input[name="sort_by"]');
    if (!el) return;
    preschTrack('sort_changed', { sort_option: el.value });
  });

  // 3. Variantenauswahl (Produktseite; Karten-Swatches bewusst ausgenommen)
  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;
    var el = e.target.closest('[data-variant-select]');
    if (!el) return;
    preschTrack('select_variant', {
      produkt_name: productTitle(),
      variant_option: el.value
    });
  });

  /**
   * 3b. Variantenwechsel bei PRESCH-Groessenfamilien.
   *
   * Der Shop hat keine Shopify-Varianten — jede Groesse ist ein eigenes
   * Produkt, verknuepft ueber `custom.variante_childs`. Die Auswahl in der
   * Kaufbox besteht deshalb aus Links, nicht aus Radios: `change` feuert dort
   * nie, und `[data-variant-select]` (Regel 3) findet auf der Standard-PDP
   * null Elemente — gemessen 9 Pillen, 0 Treffer.
   *
   * Der Klick navigiert unmittelbar danach. Das Ereignis geht trotzdem raus,
   * weil gtag.js seine Treffer per `sendBeacon` abschickt und die den
   * Seitenwechsel ueberleben; liegt es dagegen noch im dataLayer, ist es
   * verloren. Also nur fuer eingewilligte Besucher verlaesslich — bei den
   * anderen wuerde ohnehin nichts gesendet.
   */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var link = e.target.closest('[data-variant-link]');
    if (!link) return;
    preschTrack('select_variant', {
      produkt_name: productTitle(),
      variant_option: link.dataset.variantLink
    });
  });

  /**
   * 4a. Produktvideo gestartet (natives <video>; nur einmal je Video-Element).
   *
   * Zwei Filter, beide aus einer Messung: Auf der PDP der Wasserwaage liegt ein
   * Video mit `autoplay muted loop` — eine Deko-Schleife. Sie feuerte `play`
   * beim Laden, ohne dass jemand etwas angeklickt hatte, und der Treffer ging
   * bis zu GA4 durch (`en=product_video_play` bei jedem Seitenaufruf). Damit
   * zaehlte das Ereignis Seitenaufrufe, nicht Interesse.
   *
   * `autoplay` faengt den erklaerten Fall. `userActivation.hasBeenActive`
   * faengt den zweiten: ein Video, das ein Skript ohne das Attribut startet.
   * Es ist erst wahr, wenn der Besucher auf der Seite etwas getan hat — genau
   * die Unterscheidung, um die es hier geht.
   */
  var playedVideos = typeof WeakSet === 'function' ? new WeakSet() : null;
  document.addEventListener('play', function (e) {
    if (!e.target || e.target.tagName !== 'VIDEO') return;
    if (e.target.autoplay) return;
    if (navigator.userActivation && !navigator.userActivation.hasBeenActive) return;
    if (playedVideos) {
      if (playedVideos.has(e.target)) return;
      playedVideos.add(e.target);
    }
    preschTrack('product_video_play', { produkt_name: productTitle() });
  }, true);

  // 4b. 3D-Modell: erste Nutzer-Interaktion. `camera-change` bubbelt nicht,
  // ein Capture-Listener auf document fängt es trotzdem — auch für
  // model-viewer, die erst nach dem Laden ins DOM kommen (deferred media).
  var model3dSent = false;
  document.addEventListener('camera-change', function (e) {
    if (model3dSent) return;
    if (!e.target || e.target.tagName !== 'MODEL-VIEWER') return;
    if (!e.detail || e.detail.source !== 'user-interaction') return;
    model3dSent = true;
    preschTrack('product_3d_interaction', {});
  }, true);

  // 4c. Galerie: mehr als 3 Thumbnail-Klicks (einmal pro Seitenaufruf)
  var galleryClicks = 0;
  var gallerySent = false;
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-gallery-thumb]')) return;
    galleryClicks++;
    if (galleryClicks >= 3 && !gallerySent) {
      gallerySent = true;
      preschTrack('gallery_engaged', { images_viewed: galleryClicks });
    }
  });

  /**
   * 4d. Mengenrabatt gewaehlt (Produktseite, 2026-09-28).
   *
   * Drei Wege, ein Ereignis: Pille (Balken-Variante), Kachel, Dropdown der
   * Kaufzeile. `rabatt_prozent` kommt aus data-rabatt, das die Snippets aus den
   * Section-Settings schreiben (0 = Einzelpreis). So laesst sich im A/B-Test
   * zaehlen, wie oft eine Staffel angetippt wird — die Bestellungen mit
   * Rabatt stehen ohnehin im Admin (Rabattzeile „Mengenrabatt 5 %“).
   *
   * Ein Pillen-Klick setzt das Dropdown per Skript und loest dort ein
   * synthetisches `change` aus; `isTrusted` haelt das zweite Ereignis fern.
   */
  function mengenrabattEvent(quelle, menge, rabatt) {
    var m = parseInt(menge, 10);
    var r = parseFloat(String(rabatt || '0').replace(',', '.'));
    if (!isFinite(m)) return;
    preschTrack('mengenrabatt_select', {
      produkt_name: productTitle(),
      menge: m,
      rabatt_prozent: isFinite(r) ? r : 0,
      quelle: quelle
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var el = e.target.closest('.custom-mengen-balken__pille[data-menge], .custom-mengenrabatt__kachel[data-menge]');
    if (!el || el.disabled) return;
    var quelle = el.classList.contains('custom-mengenrabatt__kachel') ? 'kachel' : 'pille';
    mengenrabattEvent(quelle, el.getAttribute('data-menge'), el.getAttribute('data-rabatt'));
  });

  document.addEventListener('change', function (e) {
    if (!e.isTrusted || !e.target.closest) return;
    var sel = e.target.closest('select.custom-mengen-dropdown__select');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    mengenrabattEvent('dropdown', sel.value, opt && opt.getAttribute('data-rabatt'));
  });

  // 5. FAQ / Accordion geöffnet (details.open ist beim Öffnen-Klick noch false)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var faq = e.target.closest('details[data-faq-question]');
    if (!faq || faq.open || !faq.dataset.faqQuestion) return;
    preschTrack('faq_opened', {
      faq_question: faq.dataset.faqQuestion,
      produkt_name: productTitle()
    });
  });

  // 6a. PDF-Downloads (Anleitungen, Datenblätter)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var link = e.target.closest('a[href*=".pdf"]');
    if (!link) return;
    var path = (link.pathname || '').toLowerCase();
    if (path.slice(-4) !== '.pdf') return;
    preschTrack('file_download_manual', {
      file_name: decodeURIComponent((link.pathname || '').split('/').pop())
    });
  });

  // 6b. Hotspot geklickt (PRESCH-Hotspots sind <details>: nur das Öffnen zählen)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var hs = e.target.closest('[data-hotspot]');
    if (!hs || !hs.dataset.hotspot) return;
    var panel = hs.closest('details');
    if (panel && panel.open) return;
    preschTrack('hotspot_click', { hotspot_name: hs.dataset.hotspot });
  });

  // 7. Sprachwechsel (Horizon: name="language_code"; locale_code als Fallback)
  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;
    var el = e.target.closest('[data-locale-select], [name="language_code"], [name="locale_code"]');
    if (!el) return;
    preschTrack('locale_switch', {
      locale_from: document.documentElement.lang,
      locale_to: el.value
    });
  });

  // 8. Newsletter & Back-in-Stock (submit bubbelt; Formular lädt danach neu,
  // der Event geht aber vor der Navigation raus, sofern gtag geladen ist)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (form.matches('form[action*="contact#newsletter"], form.newsletter-form, form[data-newsletter-form]')) {
      preschTrack('newsletter_signup', {});
    }
    if (form.matches('[data-back-in-stock-form]') || form.closest('[data-back-in-stock-form]')) {
      preschTrack('back_in_stock_request', { produkt_name: productTitle() });
    }
  });

  /**
   * 9. Scrolltiefe: `scroll_depth` mit `percent_scrolled`.
   *
   * Eigenes Ereignis, nicht Googles automatisches `scroll`: Das feuert genau
   * einmal bei 90% und beantwortet damit nur die Frage "ganz unten angekommen".
   * Die Stufen hier sind so gewaehlt, dass sie sich mit den 90% NICHT
   * ueberschneiden — sonst zaehlt dieselbe Bewegung doppelt, einmal von Google
   * und einmal von uns.
   *
   * 10% ist die Stufe fuer "hat er ueberhaupt gescrollt". Sie muss so tief
   * liegen, weil unsere PDPs lang sind: Auf der Wasserwaagen-Seite sind 25%
   * schon unterhalb des Kaufbereichs, jemand der nur den Preis anschaut waere
   * darin unsichtbar.
   *
   * Gemessen wird der untere Rand des Sichtfensters, nicht die Fensteroberkante
   * (`scrollY + innerHeight`). Sonst erreicht eine kurze Seite nie 100%: Die
   * Oberkante kommt hoechstens bis `scrollHeight - innerHeight`.
   */
  var stufen = [10, 25, 50, 75, 100];
  var erreicht = {};

  function messeTiefe() {
    var hoehe = document.documentElement.scrollHeight;
    var fenster = window.innerHeight;

    // Passt die Seite ins Fenster, gibt es nichts zu scrollen. Dann auch kein
    // Ereignis — sonst meldeten kurze Seiten 100% Scrolltiefe, ohne dass sich
    // etwas bewegt hat, und die Kennzahl waere wertlos.
    if (hoehe <= fenster + 1) return;

    var anteil = ((window.scrollY + fenster) / hoehe) * 100;
    for (var i = 0; i < stufen.length; i++) {
      var stufe = stufen[i];
      if (anteil >= stufe && !erreicht[stufe]) {
        erreicht[stufe] = true;
        preschTrack('scroll_depth', {
          percent_scrolled: stufe,
          produkt_name: productTitle()
        });
      }
    }
  }

  /**
   * Ein Takt je Bildaufbau. Ein Scroll-Listener feuert sonst dutzende Male je
   * Wischbewegung, und `scrollHeight` auszulesen erzwingt jedes Mal eine neue
   * Layout-Berechnung — genau das, was auf Mobilgeraeten ruckelt.
   */
  var wartetAufBild = false;
  window.addEventListener(
    'scroll',
    function () {
      if (wartetAufBild) return;
      wartetAufBild = true;
      window.requestAnimationFrame(function () {
        wartetAufBild = false;
        messeTiefe();
      });
    },
    { passive: true }
  );

  // Einmal zu Beginn: Kommt der Besucher per Ruecknavigation zurueck, stellt
  // der Browser die alte Scrollposition wieder her, ohne dass ein Scroll-
  // Ereignis feuert. Ohne diesen Aufruf blieben die Stufen darunter stumm.
  messeTiefe();
})();
